// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"4fbf9b0b","307":"dcc90533","308":"db3b9247","360":"5edd2877","681":"754c007a","839":"833d0163","896":"770e7dd5"}[chunkId] + ".chunk.js";
};